export default "__VITE_ASSET__3b07b84b__"